import { ResultDisplayRecording } from '@/components/results/ResultDisplayRecording';
import { RESULT_DISPLAY_SIZE } from '@/constant';

import { isSlideComponentAudioRecord, Question } from '@/types/slide';
import { Box, Skeleton, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDuration } from '../../format';
import { ResultContainer, ResultContent, ResultTitle } from '../ResultCard';
import { ResultCorrectness } from '../ResultCorrectness';
import { ResultCardUnsupported } from './ResultCardUnsupported';

export const ResultCardAudioRecord: React.FC<{ question: Question }> = ({ question }) => {
    const { t } = useTranslation();

    // ui state
    const [loading, setLoading] = useState<boolean | undefined>(question.answers[0]?.fetchResultFiles ? true : false);
    const [resultFiles, setResultFiles] = useState<{ url: string }[] | undefined>(undefined);

    // init
    const audioResultFile = resultFiles?.[0];
    const timeSpent = formatDuration(question.answers.reduce((total, answer) => total + (new Date(answer.endTime).getTime() - new Date(answer.startTime).getTime()), 0) / 1000);
    const answer = question.answers[0];

    useEffect(() => {
        if (answer?.fetchResultFiles) {
            setLoading(true);
            answer
                .fetchResultFiles()
                .then((files) => {
                    setResultFiles(files);
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            setResultFiles(undefined);
        }
    }, [answer, question]);

    if (!isSlideComponentAudioRecord(question)) {
        return <ResultCardUnsupported question={question} />;
    }

    return (
        <>
            <ResultContainer>
                <Stack spacing={1}>
                    <Box sx={{ display: 'flex' }}>
                        <ResultTitle variant='h5'>{t('slide.components.audioRecord.title')}</ResultTitle>
                        <Box sx={{ flexGrow: 1 }} />
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: 280, gap: 1 }}>
                        <Typography color={question.answers.length > 0 ? 'text.secondary' : 'text.warning'}>{t('result.message.replayRecording')}</Typography>
                        {question.answers.length > 0 && (
                            <Typography color='text.secondary'>
                                {t('result.label.timeSpent')}: {timeSpent}
                            </Typography>
                        )}
                    </Box>
                </Stack>

                <ResultContent>
                    <Box sx={{ p: 4, justifyContent: 'center', display: 'flex' }}>
                        {loading ? <Skeleton variant='rounded' sx={{ width: RESULT_DISPLAY_SIZE.width, height: RESULT_DISPLAY_SIZE.height }} /> : <ResultDisplayRecording src={audioResultFile?.url} />}
                    </Box>
                </ResultContent>
                <ResultCorrectness question={question} />
            </ResultContainer>
        </>
    );
};
